import { RevProgress } from "../ds";

// Tabla de precios y clave por entorno (Amplify / .env): en Prod tienen que ser las live,
// con importes 195/875/1500 € porque el webhook asigna el crédito por el subtotal.
const pricingTableId = process.env.REACT_APP_STRIPE_PRICING_TABLE_ID;
const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

export default function StripePacks({ clientReferenceId }) {
  if (!pricingTableId || !publishableKey) {
    console.error("StripePacks: faltan REACT_APP_STRIPE_PRICING_TABLE_ID / REACT_APP_STRIPE_PUBLISHABLE_KEY");
    return null;
  }
  if (!clientReferenceId) return <RevProgress />;
  return (
    <stripe-pricing-table pricing-table-id={pricingTableId}
      publishable-key={publishableKey}
      client-reference-id={clientReferenceId}>
    </stripe-pricing-table>
  );
};
